module.exports = __webpack_public_path__ + "static/media/6.650bf1d7.jpeg";